import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {
    Button, Grid, withStyles, TextField, Typography, 
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Field, reduxForm, reset } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { styles } from '../styles';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import * as actions from '../../store/actions/members';
import Moment from 'moment';
import { subHeaderLabel, textLabelBold, isLoading } from "./meCommon";
import IcareLogo from "../../assets/images/icare_logo_transparent.png";
import moment from 'moment';

Moment.locale('en');

const validate = values => {
    const errors = {};
    const required = [];
    required.forEach((field, index) => {
        if (!values[field]) {
            errors[field] = 'Required';
        }
    });
    return errors;
};


class MemberEmail extends Component {

    constructor(props){
        super(props);
        this.state = {
            firstName : '', lastName : '', dateOfBirth : null, memberId: '', 
            error: {firstName: '', lastName: '', dateOfBirth: '', memberId: ''},
            isMemberInfo: true,
            showEmail: false
        }
    }

    componentDidMount = () => {
        setTimeout(() => {
            this.props.history.push('/contactCenter');
          }, 600000);
    }

    handleChange = (event) => {
        if(this.props.errorMessage) {
            this.props.dispatch(actions.resetErrorMsg);
        }
        let value = event.target.value;
        let name = event.target.name;
        this.setState({[name]: value});
    };

    renderTextField = (props) => {
        const {input, meta, label, isIcon, isDisabled, type, handleShow, error, required, multiline, ...custom} = props;
        return (
            <TextField
                name={input.name}
                id={input.name}
                label={label}
                error={(required && meta.touched && meta.pristine) || error}
                helperText={required && meta.touched && ((meta.pristine && <span className="text-danger">{label} is Required</span>)
                || (error && <span className="text-danger">{error}</span>)
                || (meta.warning && <span>{meta.warning}</span>))}
                margin="normal"
                variant="outlined" 
                fullWidth={true} 
                disabled={isDisabled}            
                {...input}
                {...custom}
                style={{backgroundColor: 'white'}}
                required={required}
                type={ type ? type : 'text' }  
            />
        );
    }    

    renderField = (name, label, value, required, error, password, isIcon, handleShow, isDisabled) => {
        return(
            <Field
                name={name} component={this.renderTextField} label={label} required={required}
                error={error} type={password} onChange={this.handleChange} isIcon={isIcon} handleShow={handleShow}
                isDisabled={isDisabled}
            />
        )
    }

    renderButton = (label, handler, disabled, variant, color) => {
        return (
            <Button variant={variant || "contained"} color={color || "primary"} onClick={handler} disabled={disabled}>
                {label}
                {label === "Register" && <span style={{ paddingLeft: '10px' }}>
                    {this.props.loading && (
                        <CircularProgress size={16} thickness={2} color='inherit' />
                    )}
                </span>}
            </Button>
        );
    }

    dateHandler = (name, value) => {
        this.setState({ [name]: value });
    }
    renderDate = (name, label, value) => {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label={label}
                    format="MM/dd/yyyy"
                    placeholder="MM/DD/YYYY"
                    value={value}
                    InputAdornmentProps={{ position: "end" }}
                    onChange={date => this.dateHandler(name, date)}
                    disableFuture={true}
                    clearable={"true"}
                    openTo="year"
                    views={["year", "month", "date"]}
                    fullWidth
                    required
                />
            </MuiPickersUtilsProvider>
        );
    }
    resetProfile = () => {
        if(this.props.errorMessage) {
            this.props.dispatch(actions.resetErrorMsg);
        }
    }

    handleNext() {
        let memberObj = {};
        memberObj.firstName = this.state.firstName;
        memberObj.lastName = this.state.lastName;
        memberObj.memberId = this.state.memberId;
        memberObj.validationType = "contactcenter";
        memberObj.dateOfBirth = moment(this.state.dateOfBirth).format("YYYY-MM-DD");
        this.props.dispatch(actions.validateMember(memberObj, () => {
            this.setState({ showEmail: true });
            if(this.props.errorMessage) {
                this.props.dispatch(actions.resetErrorMsg);
            }
         }));
    }

    memberInformation = () => {
        const { firstName, lastName, dateOfBirth, memberId } = this.state;
        return(
            <Grid container spacing={2} >
                <Grid item key={2} xs={12} sm={12} md={12} lg={12}>
                    {subHeaderLabel("Member Information")}
                </Grid>
                <Grid item key={3} xs={12} sm={6} md={6} lg={6}>
                    {this.renderField('firstName', 'First Name', firstName, true)}
                </Grid>
                <Grid item key={4} xs={12} sm={6} md={6} lg={6}>
                    {this.renderField('lastName', 'Last Name', lastName, true)}
                </Grid>
                <Grid item key={5} xs={12} sm={6} md={6} lg={6}>
                    {this.renderField('memberId', 'Member ID', memberId, true, this.state.error.memberId)}
                </Grid>
                <Grid item key={6} xs={12} sm={6} md={6} lg={6} style={{ paddingTop: "25px", paddingLeft: "10px" }}>
                    {this.renderDate('dateOfBirth', 'Date of Birth', dateOfBirth)}
                </Grid>
                <Grid container alignItems='flex-end' justify='flex-end'  style={{ paddingTop: "20px"}}>
                    {this.renderButton('Continue', () => this.handleNext(), !(firstName && lastName && dateOfBirth && memberId && !this.props.loading))}
                </Grid>
            </Grid>
        )
    }

    closeSuccessMessage = () => {
        if(this.state.showEmail){
            this.setState({ showEmail: false, isMemberInfo: true, firstName : '', lastName : '', memberId : '',dateOfBirth : null, });
            this.props.dispatch(reset('resetMemberEmail'));
        }
    }
    renderErrorMessage = (errorMessage) => {
        return(
            <Grid container direction="column" justify="flex-start" alignItems="flex-start" style={{ padding: "10px", border: "1px solid rgb(227, 20, 20, .23)", marginBottom: "20px" }}>
                <Typography variant="body1">Please fix the below error to move forward: </Typography>
                <Typography variant="body1" color="error">{errorMessage} </Typography>
            </Grid>
            )
    }
    renderSuccessMessage = (email) => {
        const { handleSubmit } = this.props;
        return(
            <Grid container spacing={3} >
                <Grid item key={1} xs={12} sm={12} md={12} lg={12} >
                    <Typography variant="body2" color="textSecondary" >Following email was used by user during registration </Typography>
                </Grid>
                <Grid item key={2} xs={12} sm={12} md={12} lg={12} >
                    <Typography variant="h5">{email}</Typography>
                </Grid>
                <Grid item key={3} xs={12} sm={12} md={12} lg={12} >
                        {this.renderButton('Close', handleSubmit(this.closeSuccessMessage))}
                </Grid>
            </Grid>
            )
    }

    render() {
        const { classes, errorMessage, email, loading } = this.props;
        const { isMemberInfo, showEmail } = this.state;
        return(
            <Grid container spacing={1} alignItems='center' justify='center'>
                <Grid item xs={12} sm={12} md={12} lg={12} style={{ height: "45px", backgroundColor: "#008675"}}></Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "0 45px", height: "110px"}}>
                    <Grid container direction="row" spacing={0}>
                        <Grid item key={1} xs={4} sm={4} md={4} lg={4}>
                            <Grid container direction="row" justify="center" alignItems="center">
                                <span className={classes.logo}>
                                    <img src={IcareLogo} alt="Icare" height="135px"/>
                                </span>
                            </Grid>
                        </Grid>
                        <Grid item key={2} xs={8} sm={8} md={8} lg={8} >
                            <Grid container direction="row" justify="flex-start" alignItems="center" style={{height: "135px", paddingLeft: "30px"}}>
                                {textLabelBold("h4", "Contact Center Self-Service for IDM")}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={10} sm={10} md={9} lg={8} style={{ padding: "25px", marginTop: "40px"}}>
                    { errorMessage && this.renderErrorMessage(errorMessage)}
                    { !showEmail && isMemberInfo && this.memberInformation()}
                    { showEmail && this.renderSuccessMessage(email)}
                    <Grid item key={38} xs={12} sm={12} md={12} lg={12}>
                        {loading && isLoading(loading)}
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

MemberEmail.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


const mapDispatchToProps = (dispatch) => {
    return { dispatch };
};

const mapStateToprops = (state) => {
    return {
        loading: state.members && state.members.loading,
        errorMessage: state.members && state.members.errorMessage,
        email: state.members && state.members.email,
    };
};

MemberEmail = reduxForm({ 
    form: 'resetMemberEmail' ,
    enableReinitialize: true,
    validate,
    fields: [
        'firstName', 'lastName', 'dateOfBirth', 'memberId'
    ]
})(MemberEmail);

export default compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToprops, mapDispatchToProps)
)(MemberEmail); 